import { X } from 'lucide-react';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from '@/shared/widgets/dialog';

interface ProductVideoModalProps {
  open: boolean;
  onClose: () => void;
  videoUrl: string;
  videoPosterUrl?: string;
  productName: string;
  productPageUrl?: string;
}

export default function ProductVideoModal({
  open,
  onClose,
  videoUrl,
  videoPosterUrl,
  productName,
}: ProductVideoModalProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent
        showCloseButton={false}
        aria-describedby={undefined}
        className="w-[calc(100%-3rem)] max-w-sm overflow-visible rounded-none bg-black p-0 gap-0 sm:rounded-none"
      >
        <DialogTitle className="sr-only">{productName}</DialogTitle>
        {/* key forces video element to remount when URL changes */}
        <video
          key={videoUrl}
          controls
          autoPlay
          playsInline
          poster={videoPosterUrl}
          className="block max-h-[calc(100dvh-4rem)] w-full"
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
        <DialogClose className="absolute -right-4 -top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white text-[#222] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
          <X className="h-6 w-6" aria-hidden />
          <span className="sr-only">Close</span>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
}
